﻿enum TariffKind {
	Standard,
	Internal,
	Permits,
	Reservations
}

export default TariffKind;
